export default "__VITE_ASSET__D7G$NJs7__"